/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Guide_Video_Order_RequiredInputs */

const vi_error_shop_guide_video_order_required = /** @type {(inputs: Error_Shop_Guide_Video_Order_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu danh sách thứ tự video — tải lại trang rồi kéo thả lại.`)
};

/**

* @param {Error_Shop_Guide_Video_Order_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_guide_video_order_required = /** @type {((inputs?: Error_Shop_Guide_Video_Order_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Guide_Video_Order_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_guide_video_order_required(inputs)
});